module.exports = __webpack_public_path__ + "static/mw3-d469528f9cf2648ae06cf8e20bf964f1.jpg";